/* esm.sh - d3-transition@3.0.1/src/transition/transition */
export * from "/*d3-transition@3.0.1/esnext/src/transition/transition.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/transition.mjs";
